import { RootState } from '../RootState';
import { initialPanelComerciales } from './panel_comerciales.initial';

const slice = (state: RootState) => state.panel_comerciales ?? initialPanelComerciales;

export const selectPanelComerciales = (state: RootState) => slice(state);
export const selectPanelMeta = (state: RootState) => slice(state).snapshot.meta;
/**
 * Productos retirados de la configuración del panel (decisión 2026-07): el
 * negocio no distribuye Anuncio Simple ni Smart Leads entre comerciales. El
 * backend ya los filtra vía `distribution_enabled=0`; este filtro cubre además
 * el catálogo INFERIDO de porcentajes legacy guardados (api.ts) para que no
 * reaparezcan en el editor.
 */
export const NON_CONFIGURABLE_PRODUCTS: readonly string[] = [
    'ANUNCIO_SIMPLE',
    'SMART_LEADS',
];
/** EJE PRODUCTO. Catálogo de productos (key = product_code). */
export const selectProducts = (state: RootState) =>
    (slice(state).snapshot.meta.products ?? []).filter(
        (p) => !NON_CONFIGURABLE_PRODUCTS.includes(p.key),
    );
/** EJE FLUJO. Catálogo de tipos de flujo (key = pipeline_key). */
export const selectFlowTypes = (state: RootState) =>
    slice(state).snapshot.meta.flowTypes ?? [];
export const selectTeams = (state: RootState) => slice(state).snapshot.teams;
export const selectCommercials = (state: RootState) => slice(state).snapshot.commercials;
export const selectVips = (state: RootState) => slice(state).snapshot.vips;
export const selectNotifications = (state: RootState) => slice(state).snapshot.notifications;
export const selectAuditLog = (state: RootState) => slice(state).snapshot.auditLog;
export const selectPanelLoading = (state: RootState) => slice(state).loading;
export const selectPanelSaving = (state: RootState) => slice(state).saving;
export const selectPanelError = (state: RootState) => slice(state).error;
export const selectActiveTeamNames = (state: RootState) =>
    slice(state).snapshot.teams.filter((t) => t.active).map((t) => t.name);
